import { map } from 'rxjs/operators';
import { GeneralService } from './../../../services/general.service';
import { FormGroup } from '@angular/forms';

export class FormQua007Build {
    public areaSelect: string = localStorage.getItem('area-select') || null;
    public async buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<FormGroup> {
        form = await this.buildFormI(form, arrForm[0], generalService);
        form = await this.buildFormII(form, arrForm[1], generalService);
        form = await this.buildFormIII(form, arrForm[2], generalService);
        form = await this.buildFormIV(form, arrForm[3], generalService);
        form = await this.buildFormV(form, arrForm[4], generalService);
        form = await this.buildFormVI(form, arrForm[5], generalService);
        return form;
    }

    private async buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('safra').setValue(formCard.get('Safra')?.value);
        form.get('cerar').setValue(formCard.get('Cerar')?.value);
        form.get('ordem_rw').setValue(formCard.get('Ordem_Rw')?.value); // Removido, pois não existe no JSON
        form.get('contrato_juridico').setValue(formCard.get('Contrato_Juridico')?.value);
        form.get('numero_campo').setValue(formCard.get('Nr_campo')?.value);
        form.get('cooperante').setValue(formCard.get('Cooperante')?.value);
        form.get('site_origem').setValue(formCard.get('Site_origem')?.value);
        form.get('site_recebimento').setValue(formCard.get('Site_recebimento')?.value);
        form.get('gleba').setValue(formCard.get('Gleba')?.value);
        form.get('hibrido_rnc').setValue(formCard.get('Hibrido')?.value); // Removido, pois estava incorreto
        form.get('geracao').setValue(formCard.get('Geracao')?.value);
        form.get('especie').setValue(formCard.get('Especie')?.value);
        form.get('tipo_colheita').setValue(formCard.get('Tp_colheita')?.value);
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('hibrido_rnc').setValue(formCard.get('hibrido_rnc')?.value); // Corrigido para o campo correto
            // form.get('umidade').setValue(formCard.get('Umidade')?.value);
            form.get('data_colheita').setValue(generalService.createDate(formCard.get('Dt_colheita')?.value));
            form.get('termino_enchimento').setValue(generalService.createDateTimeData(formCard.get('Termino_enchimento_data')?.value, formCard.get('Termino_enchimento_hora')?.value));
            form.get('saida_campo').setValue(generalService.createDateTimeData(formCard.get('Saida_campo_data')?.value, formCard.get('Saida_campo_hora')?.value));
            form.get('tempo_espera_campo').setValue(formCard.get('Tempo_espera_campo')?.value);
            form.get('responsavel_liberacao_colheita').setValue(formCard.get('Resp_liberacao_colheita')?.value);
            form.get('placa_carreta').setValue(formCard.get('Placa_carreta')?.value);
            form.get('transportadora').setValue(formCard.get('Transportadora')?.value);
            form.get('nfp_nota_fiscal').setValue(formCard.get('Nfp_nota_fiscal')?.value);
            // Adicionar campos faltantes:
            form.get('controle_secagem').setValue(formCard.get('controle_secagem')?.value); // Adicionado
            form.get('lote_rw').setValue(formCard.get('Lote_rw')?.value); // Adicionado
            form.get('safra_basica').setValue(formCard.get('Safra_basica')?.value);
            form.get('cerar_basica').setValue(formCard.get('Cerar_basica')?.value);
            form.get('nota_ardida').setValue(formCard.get('nota_ardida')?.value);

        }

        return await form;
    }

    private async buildFormII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        // form.get('geracao').setValue(formCard.get('Geracao')?.value);
        // form.get('especie').setValue(formCard.get('Especie')?.value);
        // form.get('tipo_colheita').setValue(formCard.get('Tp_colheita')?.value);
        if (!this.areaSelect.includes('Pré-Básica')) {
            form.get('umidade').setValue(formCard.get('Umidade')?.value);
            form.get('data_colheita').setValue(generalService.createDate(formCard.get('Dt_colheita')?.value));
            // tslint:disable-next-line: max-line-length
            form.get('termino_enchimento').setValue(generalService.createDateTimeData(formCard.get('Termino_enchimento_data')?.value, formCard.get('Termino_enchimento_hora')?.value));
            // tslint:disable-next-line: max-line-length
            form.get('saida_campo').setValue(generalService.createDateTimeData(formCard.get('Saida_campo_data')?.value, formCard.get('Saida_campo_hora')?.value));
            form.get('tempo_espera_campo').setValue(formCard.get('Tempo_espera_campo')?.value);
            form.get('responsavel_liberacao_colheita').setValue(formCard.get('Resp_liberacao_colheita')?.value);
        }

        return await form;
    }

    private async buildFormIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('ticket_n').setValue(formCard.get('Ticket')?.value);

        form.get('dt').setValue(formCard.get('Dt')?.value);
        // tslint:disable-next-line: max-line-length
        form.get('chegada_patio').setValue(generalService.createDateTimeData(formCard.get('Chegada_patio_data').value, formCard.get('Chegada_patio_hora')?.value));
        form.get('tempo_percurso').setValue(formCard.get('Tempo_percurso')?.value);
        form.get('distancia_campo_km').setValue(formCard.get('Distancia_campo')?.value);
        // tslint:disable-next-line: max-line-length
        if (!this.areaSelect.includes('Pré-Básica')) {
            form.get('data_pesagem').setValue(generalService.createDateTimeData(formCard.get('Dt_pesagem_data').value, formCard.get('Dt_pesagem_hora')?.value));
            form.get('placa_carreta').setValue(formCard.get('Placa_carreta')?.value);
            form.get('transportadora').setValue(formCard.get('Transportadora')?.value);
            form.get('nfp_nota_fiscal').setValue(formCard.get('Nfp_nota_fiscal')?.value);
        }
        else {

            // parte IV
            form.get('inicio_descarga').setValue(generalService.createDateTimeData(formCard.get('Inicio_descarga_data')?.value, formCard.get('Inicio_descarga_hora')?.value));
            form.get('tempo_espera_patio').setValue(formCard.get('Tempo_espera_patio')?.value);
            form.get('tempo_total_transporte').setValue(formCard.get('Tempo_total_transporte')?.value);
            form.get('termino_descarga').setValue(generalService.createDateTimeData(formCard.get('Termino_descarga_data')?.value, formCard.get('Termino_descarga_hora')?.value));

            // Novos campos adicionados no else

            form.get('tempo_total_de_descarga').setValue(formCard.get('Tempo_Total_de_descarga')?.value);
            form.get('amostra_seca_molhada').setValue(formCard.get('Amostra_seca_molhada')?.value);
            form.get('umidade_recebimento').setValue(formCard.get('Umidade_recebimento')?.value);
            form.get('temperatura_recebimento').setValue(formCard.get('Temperatura_recebimento')?.value);
            form.get('peso_total_rw').setValue(formCard.get('Peso_total_rw')?.value);
        }


        return await form;
    }

    private async buildFormIV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('peso_bruto_kg').setValue(formCard.get('Peso_bruto')?.value);
        form.get('peso_tara_kg').setValue(formCard.get('Peso_tara')?.value);
        form.get('peso_liquido_kg').setValue(formCard.get('Peso_liquido')?.value ?? 0);

        if (!this.areaSelect.includes('Pré-Básica')) {
            // tslint:disable-next-line: max-line-length
            form.get('inicio_descarga').setValue(generalService.createDateTimeData(formCard.get('Inicio_descarga_data')?.value, formCard.get('Inicio_descarga_hora')?.value));
            form.get('tempo_espera_patio').setValue(formCard.get('Tempo_espera_patio')?.value);
            form.get('tempo_total_transporte').setValue(formCard.get('Tempo_total_transporte')?.value);
            form.get('carga_transbordo').setValue(formCard.get('Carga_transbordo')?.value);
            if (form.get('carga_transbordo')?.value?.trim()?.toUpperCase() === 'SIM') {
                // tslint:disable-next-line: max-line-length
                form.get('saida_sdc_transbordo').setValue(generalService.createDateTimeData(formCard.get('Saida_transbordo_data')?.value, formCard.get('Saida_transbordo_hora')?.value));
                form.get('reinicio_descarga_transbordo').setValue(generalService.createDateTimeData(formCard.get('Reinicio_descarga_transbordo_data')?.value, formCard.get('Reinicio_descarga_transbordo_hora')?.value));
                form.get('tempo_transbordo').setValue(formCard.get('Tempo_transbordo')?.value);
            }
            // tslint:disable-next-line: max-line-length
            form.get('termino_descarga').setValue(generalService.createDateTimeData(formCard.get('Termino_descarga_data')?.value, formCard.get('Termino_descarga_hora')?.value));
        }

        return await form;
    }

    private async buildFormV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        form.get('tempo_descarga').setValue(formCard.get('Tempo_descarga')?.value);
        form.get('linha_descarga').setValue(formCard.get('Linha_descarga')?.value);
        form.get('status_wwb').setValue(formCard.get('Status_wwb')?.value);
        form.get('recobrimento_rolos').setValue(formCard.get('Recobrimento_rolos')?.value);
        form.get('secador_camara').setValue(formCard.get('Secador_camara')?.value);
        form.get('faixa_qualidade_genetica').setValue(formCard.get('Faixa_qualidade_genetica')?.value);
        // form.get('faixa_qualidade_fisica').setValue(formCard.get('Faixa_qualidade_fisica')?.value);
        form.get('temperatura_maxima_trajeto').setValue(formCard.get('Temp_max_trajeto')?.value);
        form.get('temperatura_maxima_tempo').setValue(formCard.get('Temp_max_total_transporte')?.value);
        form.get('apc_ligado').setValue(formCard.get('apc_ligado')?.value);

        if (this.areaSelect.includes('Pré-Básica')) {

            form.get('faixa_azul_campo').setValue(formCard.get('Fx_azul_campo')?.value ?? null);
            form.get('faixa_azul_umidade').setValue(formCard.get('Fx_azul_umidade')?.value);

            form.get('faixa_azul_tempo').setValue(formCard.get('Fx_azul_tempo_nmonitorado')?.value);
            form.get('faixa_azul_transbordo').setValue(formCard.get('Fx_azul_transbordo')?.value);
            form.get('faixa_azul_geral').setValue(formCard.get('Fx_azul_geral')?.value);

            form.get('faixa_qualidade_fisica').setValue(formCard.get('Faixa_qualidade_fisica')?.value);
            // campo novo

            form.get('faixa_azul_temperatura').setValue(formCard.get('Fx_azul_temperatura')?.value);

        }
        else {
            form.get('controle_secagem').setValue(formCard.get('Controle_secagem')?.value);

        }
        return await form;
    }

    private async buildFormVI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {





        form.get('created_by').setValue(formCard.get('criado_por')?.value);
        form.get('responsavel_lancamento').setValue(formCard.get('Resp_lancamento')?.value);
        form.get('desvio_observacoes').setValue(formCard.get('Observacao')?.value);
        form.get('semana_colheita_seq').setValue(formCard.get('Sem_colheita_sequencia')?.value);

        // form.get('ultima_carga').setValue(formCard.get('Ultima_carga')?.value);
        // tslint:disable-next-line: max-line-length
        form.get('semana_colheita_data').setValue(generalService.createDate(formCard.get('Sem_colheita_data')?.value));


        if (!this.areaSelect.includes('Pré-Básica')) {
            form.get('faixa_azul_campo').setValue(formCard.get('Fx_azul_campo')?.value ?? null);
            form.get('faixa_azul_umidade').setValue(formCard.get('Fx_azul_umidade')?.value);
            form.get('faixa_azul_tempo').setValue(formCard.get('Fx_azul_tempo_nmonitorado')?.value);
            form.get('faixa_azul_transbordo').setValue(formCard.get('Fx_azul_transbordo')?.value);
            form.get('faixa_azul_geral').setValue(formCard.get('Fx_azul_geral')?.value);
            // form.get('faixa_qualidade_genetica').setValue(formCard.get('Faixa_qualidade_genetica')?.value);
            form.get('faixa_qualidade_fisica').setValue(formCard.get('Faixa_qualidade_fisica')?.value);
            form.get('faixa_azul_temperatura').setValue(formCard.get('Fx_azul_temperatura')?.value);
            form.get('toneladas_horas_lanes').setValue(formCard.get('Tonhrlanes')?.value);
        } else {
            // Campos novos adicionados no else
            form.get('houve_desvio_documentacao').setValue(formCard.get('houve_desvio_documentacao')?.value);
            form.get('toneladas_horas_lanes').setValue(formCard.get('Tonhrlanes')?.value);
        }

        return await form;
    }

    public async updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<void> {
        await this.updateFormI(form, arrForm[0], generalService);
        await this.updateFormII(form, arrForm[1], generalService);
        await this.updateFormIII(form, arrForm[2], generalService);
        await this.updateFormIV(form, arrForm[3], generalService);
        await this.updateFormV(form, arrForm[4], generalService);
        await this.updateFormVI(form, arrForm[5], generalService);
    }

    private async updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {

        formCard.get('Safra').setValue(data.formulario.safra);
        formCard.get('Cerar').setValue(data.formulario.cerar);
        formCard.get('Contrato_Juridico').setValue(data.formulario.contrato_juridico);
        formCard.get('Nr_campo').setValue(data.formulario.numero_campo);
        formCard.get('Cooperante').setValue(data.formulario.cooperante);
        formCard.get('Site_origem').setValue(data.formulario.site_origem);
        formCard.get('Site_recebimento').setValue(data.formulario.site_recebimento);
        formCard.get('Gleba').setValue(data.formulario.gleba);

        formCard.get('Geracao').setValue(data.formulario.geracao);
        formCard.get('Especie').setValue(data.formulario.especie);
        formCard.get('Tp_colheita').setValue(data.formulario.tipo_colheita);


        if (!this.areaSelect.includes('Pré-Básica')) {

            formCard.get('Ordem_Rw').setValue(data.formulario.ordem_rw);
            formCard.get('Hibrido').setValue(data.formulario.hibrido_rnc);

        } else {
            formCard.get('Lote_rw').setValue(data.formulario.lote_rw); // Adicionado
            formCard.get('Umidade').setValue(data.formulario.umidade);
            formCard.get('Dt_colheita').setValue(generalService.convertStringToDate(data.formulario.data_colheita));
            formCard.get('Termino_enchimento_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_enchimento, true));
            formCard.get('Termino_enchimento_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_enchimento, false));
            formCard.get('Saida_campo_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.saida_campo, true));
            formCard.get('Saida_campo_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.saida_campo, false));
            formCard.get('Tempo_espera_campo').setValue(data.formulario.tempo_espera_campo);
            formCard.get('Resp_liberacao_colheita').setValue(data.formulario.responsavel_liberacao_colheita);
            formCard.get('controle_secagem').setValue(data.formulario.controle_secagem);
            formCard.get('hibrido_rnc').setValue(data.formulario.hibrido_rnc);
            formCard.get('Placa_carreta').setValue(data.formulario.placa_carreta);
            formCard.get('Transportadora').setValue(data.formulario.transportadora);

            formCard.get('Nfp_nota_fiscal').setValue(data.formulario.nfp_nota_fiscal);

            formCard.get('Safra_basica').setValue(data.formulario.safra_basica);
            formCard.get('Cerar_basica').setValue(data.formulario.cerar_basica);
            formCard.get('nota_ardida').setValue(data.formulario.nota_ardida);
        }
    }

    private async updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        // formCard.get('Geracao').setValue(data.formulario.geracao);
        // formCard.get('Especie').setValue(data.formulario.especie);
        // formCard.get('Tp_colheita').setValue(data.formulario.tipo_colheita);


        if (!this.areaSelect.includes('Pré-Básica')) {

            formCard.get('Umidade').setValue(data.formulario.umidade);
            formCard.get('Dt_colheita').setValue(generalService.convertStringToDate(data.formulario.data_colheita));
            // tslint:disable-next-line: max-line-length
            formCard.get('Termino_enchimento_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_enchimento, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Termino_enchimento_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_enchimento, false));
            // tslint:disable-next-line: max-line-length
            formCard.get('Saida_campo_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.saida_campo, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Saida_campo_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.saida_campo, false));
            formCard.get('Tempo_espera_campo').setValue(data.formulario.tempo_espera_campo);
            formCard.get('Resp_liberacao_colheita').setValue(data.formulario.responsavel_liberacao_colheita);

        }

    }

    private async updateFormIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        // Campos comuns para todas as condições


        formCard.get('Chegada_patio_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.chegada_patio, true));
        formCard.get('Chegada_patio_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.chegada_patio, false));
        formCard.get('Tempo_percurso').setValue(data.formulario.tempo_percurso);
        formCard.get('Distancia_campo').setValue(data.formulario.distancia_campo_km);


        // Bloco if: Campos que devem ser tratados apenas se `!this.areaSelect.includes('Pré-Básica')`
        if (!this.areaSelect.includes('Pré-Básica')) {
            // Você pode adicionar lógica específica aqui, se necessário
            formCard.get('Ticket').setValue(data.formulario.ticket_n);
            formCard.get('Placa_carreta').setValue(data.formulario.placa_carreta);
            formCard.get('Transportadora').setValue(data.formulario.transportadora);
            formCard.get('Dt').setValue(data.formulario.dt);
            formCard.get('Nfp_nota_fiscal').setValue(data.formulario.nfp_nota_fiscal);
            formCard.get('Dt_pesagem_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_pesagem, true));
            formCard.get('Dt_pesagem_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_pesagem, false));
        } else {


            // Campos específicos para o bloco `else`
            formCard.get('Inicio_descarga_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_descarga, true));
            formCard.get('Inicio_descarga_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_descarga, false));

            formCard.get('Termino_descarga_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_descarga, true));
            formCard.get('Termino_descarga_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_descarga, false));
            formCard.get('Tempo_Total_de_descarga').setValue(data.formulario.tempo_total_de_descarga);
            formCard.get('Amostra_seca_molhada').setValue(data.formulario.amostra_seca_molhada);
            formCard.get('Umidade_recebimento').setValue(data.formulario.umidade_recebimento);
            formCard.get('Temperatura_recebimento').setValue(data.formulario.temperatura_recebimento);
            formCard.get('Peso_total_rw').setValue(data.formulario.peso_total_rw);
        }

    }

    private async updateFormIV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            formCard.get('Peso_bruto').setValue(data.formulario.peso_bruto_kg);
            formCard.get('Peso_tara').setValue(data.formulario.peso_tara_kg);
            formCard.get('Peso_liquido').setValue(data.formulario.peso_liquido_kg ?? 0);
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_descarga_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_descarga, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_descarga_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_descarga, false));
            formCard.get('Tempo_espera_patio').setValue(data.formulario.tempo_espera_patio);
            // tslint:disable-next-line: max-line-length
            formCard.get('Tempo_total_transporte').setValue(data.formulario.tempo_total_transporte);
            formCard.get('Carga_transbordo').setValue(data.formulario.carga_transbordo);
            formCard.get('Tempo_transbordo').setValue(data.formulario.tempo_transbordo);
            if (data?.formulario?.carga_transbordo?.trim()?.toUpperCase() === 'SIM') {
                // tslint:disable-next-line: max-line-length
                formCard.get('Saida_transbordo_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.saida_sdc_transbordo, true));
                // tslint:disable-next-line: max-line-length
                formCard.get('Saida_transbordo_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.saida_sdc_transbordo, false));
                // tslint:disable-next-line: max-line-length
                formCard.get('Reinicio_descarga_transbordo_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.reinicio_descarga_transbordo, true));
                // tslint:disable-next-line: max-line-length
                formCard.get('Reinicio_descarga_transbordo_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.reinicio_descarga_transbordo, false));
            }
            // tslint:disable-next-line: max-line-length
            formCard.get('Termino_descarga_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_descarga, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Termino_descarga_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_descarga, false));
        }

    }

    private async updateFormV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {




        // Bloco if: para campos específicos de uma condição
        if (!this.areaSelect.includes('Pré-Básica')) {
            // Adicione os campos que são exclusivos para esta condição, se houver
            formCard.get('Controle_secagem').setValue(data.formulario.controle_secagem);
            formCard.get('Secador_camara').setValue(data.formulario.secador_camara);
            formCard.get('apc_ligado').setValue(data.formulario.apc_ligado);
            formCard.get('Temp_max_trajeto').setValue(data.formulario.temperatura_maxima_trajeto);
            formCard.get('Temp_max_total_transporte').setValue(data.formulario.temperatura_maxima_tempo);
            // Campos comuns para ambas as condições (se existir)
            formCard.get('Tempo_descarga').setValue(data.formulario.tempo_descarga);
            formCard.get('Linha_descarga').setValue(data.formulario.linha_descarga);
            formCard.get('Status_wwb').setValue(data.formulario.status_wwb);
            formCard.get('Recobrimento_rolos').setValue(data.formulario.recobrimento_rolos?.toString());

        } else {

            data.formulario.faixa_azul_campo = data.formulario.faixa_azul_campo?.split(',');

            // Campos específicos para a condição onde `this.areaSelect.includes('Pré-Básica')`

            formCard.get('Faixa_qualidade_fisica').setValue(data.formulario.faixa_qualidade_fisica);
            formCard.get('Faixa_qualidade_genetica').setValue(data.formulario.faixa_qualidade_genetica);
            formCard.get('Fx_azul_campo').setValue(data.formulario.faixa_azul_campo as string[]);
            formCard.get('Fx_azul_umidade').setValue(data.formulario.faixa_azul_umidade);
            formCard.get('Fx_azul_tempo_nmonitorado').setValue(data.formulario.faixa_azul_tempo);
            formCard.get('Fx_azul_transbordo').setValue(data.formulario.faixa_azul_transbordo);
            formCard.get('Fx_azul_geral').setValue(data.formulario.faixa_azul_geral);
            formCard.get('Fx_azul_temperatura').setValue(data.formulario.faixa_azul_temperatura);
        }

        // Campos comuns para ambas as condições

    }

    private async updateFormVI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {



        formCard.get('criado_por').setValue(data.formulario.created_by);
        formCard.get('Resp_lancamento').setValue(data.formulario.responsavel_lancamento);
        formCard.get('Observacao').setValue(data.formulario.desvio_observacoes);
        formCard.get('Sem_colheita_sequencia').setValue(data.formulario.semana_colheita_seq);
        // formCard.get('Ultima_carga').setValue(data.formulario.ultima_carga);
        formCard.get('Sem_colheita_data').setValue(generalService.convertStringToDate(data.formulario.semana_colheita_data));

        // Verificando os campos adicionais do JSON e aplicando lógica condicional
        if (!this.areaSelect.includes('Pré-Básica')) {
            // Colocar novos campos aqui, se necessário para essa condição

            formCard.get('Fx_azul_umidade').setValue(data.formulario.faixa_azul_umidade);
            formCard.get('Fx_azul_temperatura').setValue(data.formulario.faixa_azul_temperatura);
            formCard.get('Fx_azul_tempo_nmonitorado').setValue(data.formulario.faixa_azul_tempo);
            formCard.get('Fx_azul_transbordo').setValue(data.formulario.faixa_azul_transbordo);
            formCard.get('Fx_azul_geral').setValue(data.formulario.faixa_azul_geral);
            // formCard.get('Faixa_qualidade_genetica').setValue(data.formulario.faixa_qualidade_genetica);
            formCard.get('Faixa_qualidade_fisica').setValue(data.formulario.faixa_qualidade_fisica);
            const faixaAzulCampo = data.formulario.faixa_azul_campo;
            const parsedValue = faixaAzulCampo ? faixaAzulCampo.split(',') : [];
            formCard.get('Fx_azul_campo').setValue(parsedValue);
            formCard.get('Fx_azul_umidade').setValue(data.formulario.faixa_azul_umidade);
            formCard.get('Fx_azul_transbordo').setValue(data.formulario.faixa_azul_transbordo);
            formCard.get('Tonhrlanes').setValue(data.formulario.toneladas_horas_lanes);

        } else {
            // Colocar campos específicos para a condição em que 'Pré-Básica' está incluída


            formCard.get('houve_desvio_documentacao').setValue(data.formulario.houve_desvio_documentacao);
        }


    }
}
